module.exports = __webpack_public_path__ + "img/hld.27e59fd2.svg";